<template>
	<div>
		<StandardModal
			open
			small
			:title="$t('admin_categories_new_category_title')"
			:confirmText="$t('common_button_create')"
			:confirmProps="{ disabled, loading: isCreating }"
			@confirm="createCategory"
			@cancel="close"
			ref="newModal"
			class="new-modal"
		>
			<template #trigger>
				<slot />
			</template>
			<FormItem
				:label="$t('admin_categories_category_name_label')"
				:error="!!errors.title"
				:message="errors.title"
			>
				<Input
					v-model="title"
					autoFocus
					@enter="createCategory"
					ref="titleInput"
				/>
			</FormItem>
		</StandardModal>

		<StandardModal
			v-if="newCategory"
			open
			:title="$t('admin_categories_new_category_title')"
			:confirmText="$t('common_button_done')"
			:cancelText="$t('admin_categories_create_another_action')"
			@confirm="close"
			@cancel="goBackToNewModal"
			ref="successModal"
			class="success-modal"
		>
			<div class="success-top-content">
				<GroupsIcon class="groups-icon" halo />
				<div class="success-top-title">
					{{
						$t('admin_common_added_success_label', {
							GroupName: newCategory.title,
						})
					}}
				</div>
			</div>
			<div class="success-actions">
				<div class="success-actions-label" v-t="'admin_groups_next_steps'" />
				<RouterLink
					class="success-action-item"
					v-for="action in successActions"
					:key="action.id"
					:to="action.link"
				>
					<div>
						<component :is="action.icon" />
						{{ $t(action.text) }}
					</div>
					<div class="action-link" v-text="$t(action.linkText)" />
				</RouterLink>
			</div>
		</StandardModal>
	</div>
</template>

<script>
import { Input, StandardModal, FormItem } from '@/components/common'
import { post } from '../common'
import { GroupsIcon, DetailsIcon } from '@/icons'
import { storage } from '@/helpers/utils'

export default {
	name: 'NewCategoryModal',
	components: { StandardModal, FormItem, Input, GroupsIcon },
	props: {
		showSuccess: { type: Boolean, default: null },
	},
	data() {
		return {
			open: false,
			title: null,
			newCategory: null,
			isCreating: false,
			errors: {},
		}
	},
	emits: ['create', 'close'],
	computed: {
		trimmedTitle() {
			return this.title?.trim()
		},
		disabled() {
			return !this.trimmedTitle
		},
		successActions() {
			return [
				{
					icon: GroupsIcon,
					text: 'admin_categories_add_groups_to_cateogry_action',
					linkText: 'admin_categories_add_groups_action',
					link: {
						path: `/organization/categories/${this.newCategory?.id}`,
						query: {
							newGroup: 'true',
						},
					},
				},
				{
					icon: DetailsIcon,
					text: 'admin_categories_view_details_action',
					linkText: 'admin_groups_open_details_button',
					link: `/organization/categories/${this.newCategory?.id}`,
				},
			]
		},
	},
	methods: {
		async createCategory() {
			this.modalError?.()
			this.errors = {}
			this.isCreating = true
			const payload = {
				title: this.title,
			}

			try {
				const category = await post('/organization/categories', payload)
				this.$emit('create', category)
				this.isCreating = false
				this.title = null
				storage.set('org_mgmt_changed_categories', true)
				if (this.showSuccess) {
					this.newCategory = category
				} else {
					this.close()
				}
			} catch (e) {
				this.displayErrors(e)
				this.isCreating = false
			}
		},
		close() {
			this.title = null
			this.newCategory = null
			this.$emit('close')
		},
		goBackToNewModal() {
			this.newCategory = null
			this.$nextTick(() => {
				this.$refs.titleInput.focus()
			})
		},

		displayErrors(e) {
			console.error(e)
			if (!e.response?.data?.errors) {
				this.modalError = this.$refs.newModal.$alert.error()
				return
			}
			this.errors = Object.entries(e.response?.data?.errors).reduce(
				(acc, [key, errors]) => {
					acc[key] = errors[0].message
					return acc
				},
				{}
			)
		},
	},
}
</script>

<style lang="scss">
@import 'src/sass/variables';

.success-modal {
	.modal-body {
		padding: 24px;

		.success-top-content {
			@include flex-column;
			align-items: center;
			margin: 56px 0;
			.success-top-title {
				font-family: Avenir-Heavy;
				font-size: 24px;
			}
			.pronto-icon {
				font-size: 55px;
				color: var(--blue-300);
				margin-bottom: 24px;
			}
		}
		.success-actions {
			.success-actions-label {
				font-family: Avenir-Heavy;
				padding: 0 16px;
				margin-bottom: 8px;
			}
			.success-action-item {
				@include flex-spread;
				height: 50px;
				border-radius: 6px;
				padding: 0 16px;
				cursor: pointer;
				margin-bottom: 8px;
				color: inherit;
				text-decoration: none;
				&:hover {
					background: rgba($pronto-blue, 0.1);
				}
				> div {
					@include flex;
				}
				.pronto-icon {
					color: var(--blue-300);
					font-size: 20px;
					margin-right: 12px;
				}
				.action-link {
					color: var(--blue-300);
				}
			}
		}
		.groups-icon {
			font-size: 66px !important;
		}
	}
}
</style>
